import { Alignment, WidgetSize } from './enum';

export const courierNameOptions = [
  { label: 'Custom', value: 'custom' },
  { label: 'DHL', value: 'DHL' },
  { label: 'Ali Express', value: 'Ali Express' },
  { label: 'Australia Post', value: 'Australia Post' },
  { label: 'Bpost', value: 'Bpost' },
  { label: 'Russian Post', value: 'Russian Post' },
  { label: 'Sweden Posten', value: 'Sweden Posten' },
  { label: 'Shippit', value: 'Shippit' },
  { label: 'Antilles Post', value: 'Antilles Post' },
  { label: 'Azerbaijan Post', value: 'Azerbaijan Post' },
  { label: 'Belarus Post', value: 'Belarus Post' },
  { label: 'YANWEN', value: 'YANWEN' },
  { label: 'Kerry eCommerce', value: 'Kerry eCommerce' },
  { label: 'Weaship', value: 'Weaship' },
  { label: 'DHL Global Forwarding', value: 'DHL Global Forwarding' },
  { label: 'Pitney Bowes', value: 'Pitney Bowes' },
  { label: 'EWS Profit Fields', value: 'EWS Profit Fields' },
  { label: 'UBon Express', value: 'UBon Express' },
  { label: 'Chukou1 Logistics', value: 'Chukou1 Logistics' },
  { label: 'Hermesworld', value: 'Hermesworld' },
  { label: 'Hermes Germany', value: 'Hermes Germany' },
  { label: 'New Zealand Post', value: 'New Zealand Post' },
  { label: 'FBA ES Swiship', value: 'FBA ES Swiship' },
  { label: '99minutos', value: '99minutos' },
  { label: 'Fedex', value: 'Fedex' },
  { label: 'USPS', value: 'USPS' },
  { label: 'TNT', value: 'TNT' },
  { label: 'DHL Express', value: 'DHL Express' },
  { label: 'China Post', value: 'China Post' },
  { label: 'DHL ECommerce', value: 'DHL ECommerce' },
  { label: 'DHL Global Mail Asia', value: 'DHL Global Mail Asia' },
  { label: 'Canada Post', value: 'Canada Post' },
  { label: 'CJ Packet', value: 'CJ Packet' },
  { label: 'Couriers Please express', value: 'Couriers Please express' },
  { label: 'DPD', value: 'DPD' },
  { label: 'Sendle', value: 'Sendle' },
  { label: 'Aramex', value: 'Aramex' },
  { label: 'China EMS (ePacket)', value: 'China EMS (ePacket)' },
  { label: 'UBI Smart Parcel', value: 'UBI Smart Parcel' },
  {
    label: 'Fastway New Zealand (Aramex)',
    value: 'Fastway New Zealand (Aramex)',
  },
  {
    label: 'Fastway Australia (Aramex)',
    value: 'Fastway Australia (Aramex)',
  },
  {
    label: 'Fastway Ireland (Aramex)',
    value: 'Fastway Ireland (Aramex)',
  },
  { label: 'Nexive', value: 'Nexive' },
  { label: 'Colissimo', value: 'Colissimo' },
  { label: 'NZ Post', value: 'NZ Post' },
  { label: 'Bring', value: 'Bring' },
  { label: 'Posten Norge', value: 'Posten Norge' },
  { label: 'Oman Post', value: 'Oman Post' },
  {
    label: 'Overseas Territory US Post',
    value: 'Overseas Territory US Post',
  },
  { label: 'Asendia USA', value: 'Asendia USA' },
  { label: 'Asendia UK', value: 'Asendia UK' },
  { label: 'Asendia Germany', value: 'Asendia Germany' },
];

export const optionsPerPage = [
  { label: '5', value: '5' },
  { label: '10', value: '10' },
  { label: '25', value: '25' },
  { label: '50', value: '50' },
  { label: '75', value: '75' },
  { label: '100', value: '100' },
];

export const optionsRating = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
];

export const orderLookupOptions = {
  size: [
    {
      label: 'Large',
      value: WidgetSize.Large,
    },
    {
      label: 'Medium',
      value: WidgetSize.Medium,
    },
    {
      label: 'Small',
      value: WidgetSize.Small,
    },
  ],

  alignment: [
    {
      label: 'Center',
      value: Alignment.Center,
    },
    {
      label: 'Left',
      value: Alignment.Left,
    },
    {
      label: 'Right',
      value: Alignment.Right,
    },
  ],
};

// Full set of languages a merchant can add to a tracking page (Shopify locale codes).
export const languageOptions: Array<{ value: string; label: string }> = [
  { value: 'af', label: 'Afrikaans' },
  { value: 'ak', label: 'Akan' },
  { value: 'sq', label: 'Albanian' },
  { value: 'am', label: 'Amharic' },
  { value: 'ar', label: 'Arabic' },
  { value: 'hy', label: 'Armenian' },
  { value: 'as', label: 'Assamese' },
  { value: 'az', label: 'Azerbaijani' },
  { value: 'bm', label: 'Bambara' },
  { value: 'bn', label: 'Bangla' },
  { value: 'eu', label: 'Basque' },
  { value: 'be', label: 'Belarusian' },
  { value: 'bs', label: 'Bosnian' },
  { value: 'br', label: 'Breton' },
  { value: 'bg', label: 'Bulgarian' },
  { value: 'my', label: 'Burmese' },
  { value: 'ca', label: 'Catalan' },
  { value: 'ckb', label: 'Central Kurdish' },
  { value: 'ce', label: 'Chechen' },
  { value: 'zh-CN', label: 'Chinese (Simplified)' },
  { value: 'zh-TW', label: 'Chinese (Traditional)' },
  { value: 'kw', label: 'Cornish' },
  { value: 'hr', label: 'Croatian' },
  { value: 'cs', label: 'Czech' },
  { value: 'da', label: 'Danish' },
  { value: 'nl', label: 'Dutch' },
  { value: 'dz', label: 'Dzongkha' },
  { value: 'en', label: 'English' },
  { value: 'eo', label: 'Esperanto' },
  { value: 'et', label: 'Estonian' },
  { value: 'ee', label: 'Ewe' },
  { value: 'fo', label: 'Faroese' },
  { value: 'fil', label: 'Filipino' },
  { value: 'fi', label: 'Finnish' },
  { value: 'fr', label: 'French' },
  { value: 'ff', label: 'Fulah' },
  { value: 'gl', label: 'Galician' },
  { value: 'lg', label: 'Ganda' },
  { value: 'ka', label: 'Georgian' },
  { value: 'de', label: 'German' },
  { value: 'el', label: 'Greek' },
  { value: 'gu', label: 'Gujarati' },
  { value: 'ha', label: 'Hausa' },
  { value: 'he', label: 'Hebrew' },
  { value: 'hi', label: 'Hindi' },
  { value: 'hu', label: 'Hungarian' },
  { value: 'is', label: 'Icelandic' },
  { value: 'ig', label: 'Igbo' },
  { value: 'id', label: 'Indonesian' },
  { value: 'ia', label: 'Interlingua' },
  { value: 'ga', label: 'Irish' },
  { value: 'it', label: 'Italian' },
  { value: 'ja', label: 'Japanese' },
  { value: 'jv', label: 'Javanese' },
  { value: 'kl', label: 'Kalaallisut' },
  { value: 'kn', label: 'Kannada' },
  { value: 'ks', label: 'Kashmiri' },
  { value: 'kk', label: 'Kazakh' },
  { value: 'km', label: 'Khmer' },
  { value: 'ki', label: 'Kikuyu' },
  { value: 'rw', label: 'Kinyarwanda' },
  { value: 'ko', label: 'Korean' },
  { value: 'ku', label: 'Kurdish' },
  { value: 'ky', label: 'Kyrgyz' },
  { value: 'lo', label: 'Lao' },
  { value: 'lv', label: 'Latvian' },
  { value: 'ln', label: 'Lingala' },
  { value: 'lt', label: 'Lithuanian' },
  { value: 'lu', label: 'Luba-Katanga' },
  { value: 'lb', label: 'Luxembourgish' },
  { value: 'mk', label: 'Macedonian' },
  { value: 'mg', label: 'Malagasy' },
  { value: 'ms', label: 'Malay' },
  { value: 'ml', label: 'Malayalam' },
  { value: 'mt', label: 'Maltese' },
  { value: 'gv', label: 'Manx' },
  { value: 'mr', label: 'Marathi' },
  { value: 'mn', label: 'Mongolian' },
  { value: 'mi', label: 'Māori' },
  { value: 'ne', label: 'Nepali' },
  { value: 'nd', label: 'North Ndebele' },
  { value: 'se', label: 'Northern Sami' },
  { value: 'no', label: 'Norwegian' },
  { value: 'nb', label: 'Norwegian (Bokmål)' },
  { value: 'nn', label: 'Norwegian Nynorsk' },
  { value: 'or', label: 'Odia' },
  { value: 'om', label: 'Oromo' },
  { value: 'os', label: 'Ossetic' },
  { value: 'ps', label: 'Pashto' },
  { value: 'fa', label: 'Persian' },
  { value: 'pl', label: 'Polish' },
  { value: 'pt-BR', label: 'Portuguese (Brazil)' },
  { value: 'pt-PT', label: 'Portuguese (Portugal)' },
  { value: 'pa', label: 'Punjabi' },
  { value: 'qu', label: 'Quechua' },
  { value: 'ro', label: 'Romanian' },
  { value: 'rm', label: 'Romansh' },
  { value: 'rn', label: 'Rundi' },
  { value: 'ru', label: 'Russian' },
  { value: 'sg', label: 'Sango' },
  { value: 'sa', label: 'Sanskrit' },
  { value: 'sc', label: 'Sardinian' },
  { value: 'gd', label: 'Scottish Gaelic' },
  { value: 'sr', label: 'Serbian' },
  { value: 'sn', label: 'Shona' },
  { value: 'ii', label: 'Sichuan Yi' },
  { value: 'sd', label: 'Sindhi' },
  { value: 'si', label: 'Sinhala' },
  { value: 'sk', label: 'Slovak' },
  { value: 'sl', label: 'Slovenian' },
  { value: 'so', label: 'Somali' },
  { value: 'es', label: 'Spanish' },
  { value: 'su', label: 'Sundanese' },
  { value: 'sw', label: 'Swahili' },
  { value: 'sv', label: 'Swedish' },
  { value: 'tg', label: 'Tajik' },
  { value: 'ta', label: 'Tamil' },
  { value: 'tt', label: 'Tatar' },
  { value: 'te', label: 'Telugu' },
  { value: 'th', label: 'Thai' },
  { value: 'bo', label: 'Tibetan' },
  { value: 'ti', label: 'Tigrinya' },
  { value: 'to', label: 'Tongan' },
  { value: 'tr', label: 'Turkish' },
  { value: 'tk', label: 'Turkmen' },
  { value: 'uk', label: 'Ukrainian' },
  { value: 'ur', label: 'Urdu' },
  { value: 'ug', label: 'Uyghur' },
  { value: 'uz', label: 'Uzbek' },
  { value: 'vi', label: 'Vietnamese' },
  { value: 'cy', label: 'Welsh' },
  { value: 'fy', label: 'Western Frisian' },
  { value: 'wo', label: 'Wolof' },
  { value: 'xh', label: 'Xhosa' },
  { value: 'yi', label: 'Yiddish' },
  { value: 'yo', label: 'Yoruba' },
  { value: 'zu', label: 'Zulu' },
];
